module.exports = __webpack_public_path__ + "media/img/frontend_application/christmas/top-decoration-0fa5c42db78ccd7298bda0301dd334c4.png";